<template>
    <div class="mid-pane">
        <!--    Mobile left Pane-->
        <mobile-left-bar></mobile-left-bar>
        <!--    Mobile left Pane END-->

        <div class="hold">
            <!--        NavBar-->
            <div class="nav-bar">
                <div class="nav-hold">
                    <div class="back-icon" @click="backButton()">
                <span>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 31.1 31.1">
                        <path d="M30.2 16.4H0.9C0.4 16.4 0 16 0 15.5c0-0.5 0.4-0.9 0.9-0.9h29.3c0.5 0 0.9 0.4 0.9 0.9C31.1 16 30.7 16.4 30.2 16.4z" class="a"></path>
                        <path d="M16 31.1c-0.2 0-0.4-0.1-0.6-0.2L0.3 16.2C0.1 16 0 15.8 0 15.5c0-0.2 0.1-0.5 0.3-0.6L15.4 0.3c0.4-0.3 0.9-0.3 1.3 0 0.3 0.4 0.3 0.9 0 1.3L2.2 15.5l14.5 14c0.4 0.3 0.4 0.9 0 1.3C16.5 31 16.2 31.1 16 31.1z"></path>
                    </svg>
                </span>
                    </div>

                    <div class="nav-text alt">
                        <p class="main">Money Request</p>
                    </div>
                </div>
            </div>


            <!--        Intro Text-->
            <div class="all-account-component">
                <div class="all-accounts">

                    <div class="all-account-top i-banker-mob">
                        <div class="row">
                            <div class="col-lg-6 col-md-6 col-sm-6 col-7">
                                <div class="hold">
                                    <div class="request-switch">
                                        <ui-switch
                                                v-model="requestSwitch" color="accent"
                                                checked @change="reviewSwitchState()"
                                        >
                                            <p v-if="requestSwitch" class="pageSubHeader">Sent Requests</p>
                                            <p v-else class="pageSubHeader">Received Requests</p>
                                        </ui-switch>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-6 col-md-6 col-sm-6 col-5">
                                <div class="balance">
                                    <a @click="startNewMoneyRequest()" class="xnax-btn-alt">New Request</a>
                                </div>
                            </div>
                        </div>
                    </div>



                    <div class="ibanker-table mt-2">
                        <div class="">
                            <!--<div class="header">-->
                            <!--<div class="row">-->
                            <!--<div class="col-sm-12">-->
                            <!--<p class="mb-0">Customers</p>-->
                            <!--</div>-->
                            <!--</div>-->
                            <!--</div>-->

                            <div class="history-table">
                                <div class="tbl">
                                    <div v-if="currentMoneyRequestList.toString() === ''">
                                        <div class="empty-history">
                                            <span>
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50">
                                                    <circle cx="25" cy="25" r="25"></circle>
                                                    <line x1="25" y1="10" x2="25" y2="32" class="a"></line>
                                                    <line x1="25" y1="37" x2="25" y2="39" class="a"></line>
                                                </svg>
                                            </span>
                                            <p>
                                                {{fetchError}}
                                            </p>
                                        </div>
                                    </div>
                                    <div v-else>
                                        <div v-for="request in currentMoneyRequestList" class="account-statement-group">
                                            <div>
                                                <div class="account-statement">
                                                    <article class="amount">
                                                        <div v-if="request.senderaction ==='PENDING'" class="myb"></div>
                                                        <div v-else-if="request.senderaction ==='approve'" class="crd"></div>
                                                        <div v-else class="dbt"></div>

                                                        {{request.requestdate | formatDateRelatively}}
                                                    </article>
                                                    <article class="type">
                                                        <div v-if="requestSwitch">
                                                            {{request.sendername}}
                                                        </div>
                                                        <div v-else>
                                                            {{request.requestername}}
                                                        </div>
                                                    </article>
                                                    <article class="counterparty">
                                                        <span class="currency">&#8358;</span>
                                                        {{request.requestamount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}
                                                    </article>
                                                    <article class="icon">
                                                        <div v-if="requestSwitch">
                                                            <a @click="moreRequestInfo(request)">
                                                            <span>
                                                                <i class="nav-icon i-Information"></i>
                                                            </span>
                                                            </a>
                                                        </div>
                                                        <div v-else>
                                                            <a @click="requestAction(request)">
                                                            <span>
                                                                <i class="nav-icon i-Information"></i>
                                                            </span>
                                                            </a>
                                                        </div>
                                                    </article>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!--UI Modal For Displaying Full Transaction Details-->
                <ui-modal
                        ref="fullMoneyRequestModal" transition="scale-up"
                        :removeHeader= "true" size="small" @hide="fullMoneyRequestModalHide"
                        align-top :align-top-margin="100"
                >
                    <div class="notification-modal sm">
                        <div class="head">
                            <div class="logo-hold">
                                <div>
                                    <img src="https://assets-base.s3.amazonaws.com/img/rubies/logo-sm.png" alt="" class="logo">
                                </div>
                            </div>
                        </div>

                        <div class="bottom">
                            <div class="modal-body history">
                                <div class="">
                                    <div class="trnxHist">
                                        <div class="row">
                                            <div class="col-lg-4 col-md-4 col-sm-4 col-4">
                                                <div class="logo alt">
                                                    <img
                                                            src="https://rubies-ibank-test-two.s3-us-west-2.amazonaws.com/img/money-request.png"
                                                            class="" alt=""
                                                    >
                                                </div>
                                            </div>
                                            <div class="col-lg-8 col-md-8 col-sm-8 col-8 text-right">
                                                <div class="amount">
                                                    <div class="crdDbt">
                                                    <span v-if="currentMoneyRequest.senderaction === 'PENDING'">
                                                        <!--Pending-->
                                                        <span class="myb"></span>
                                                    </span>
                                                        <span v-else-if="currentMoneyRequest.senderaction === 'approve'">
                                                        <!--Approved-->
                                                        <span class="crd"></span>
                                                    </span>
                                                        <span v-else>
                                                        <!--Declined-->
                                                        <span class="dbt"></span>
                                                    </span>
                                                    </div>

                                                    <p v-if="currentMoneyRequest.requestamount">
                                                        <span class="currency">₦</span>
                                                        {{currentMoneyRequest.requestamount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <!--<p><{{currentMoneyRequestList}}/p>-->

                                    <div class="trnxHist">
                                        <div class="row">
                                            <div class="col-lg-4 col-md-4 col-sm-4 col-4">
                                                <p class="histLabel">To</p>
                                            </div>
                                            <div class="col-lg-8 col-md-8 col-sm-8 col-8 text-right">
                                                <p class="histRecord">{{currentMoneyRequest.sendername}} ({{currentMoneyRequest.senderaccountnumber}})</p>
                                            </div>
                                        </div>
                                    </div>
                                    <hr>

                                    <div class="trnxHist">
                                        <div class="row">
                                            <div class="col-lg-4 col-md-4 col-sm-4 col-4">
                                                <p class="histLabel">Date</p>
                                            </div>
                                            <div class="col-lg-8 col-md-8 col-sm-8 col-8 text-right">
                                                <p class="histRecord">{{currentMoneyRequest.requestdate | formatDateRelatively}}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <hr>

                                    <div class="trnxHist">
                                        <div class="row">
                                            <div class="col-lg-4 col-md-4 col-sm-4 col-4">
                                                <p class="histLabel">Reason</p>
                                            </div>
                                            <div class="col-lg-8 col-md-8 col-sm-8 col-8 text-right">
                                                <p class="histRecord">{{currentMoneyRequest.reason}}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="modal-button alt pb-2">
                                <button @click="closeModal('fullMoneyRequestModal')" class="btn btn-primary btn-xnax-login">Close</button>
                                <!--<button @click="closeModal('fullHistoryModal')" class="btn btn-primary btn-xnax-login alt">Request Money</button>-->
                            </div>
                        </div>
                    </div>
                </ui-modal>



                <!--UI Modal For Displaying Full Transaction Details-->
                <ui-modal
                        ref="moneyRequestActionModal" transition="scale-up"
                        :removeHeader= "true" size="small" @hide="fullMoneyRequestModalHide"
                        align-top :align-top-margin="100"
                >
                    <div class="notification-modal sm">
                        <div class="head">
                            <div class="logo-hold">
                                <div>
                                    <img src="https://assets-base.s3.amazonaws.com/img/rubies/logo-sm.png" alt="" class="logo">
                                </div>
                            </div>
                        </div>

                        <div class="bottom">
                            <div class="modal-body history">
                                <div class="">
                                    <div class="trnxHist">
                                        <div class="row">
                                            <div class="col-lg-4 col-md-4 col-sm-4 col-4">
                                                <div class="logo alt">
                                                    <img
                                                            src="https://rubies-ibank-test-two.s3-us-west-2.amazonaws.com/img/money-request.png"
                                                            class="" alt=""
                                                    >
                                                </div>
                                            </div>
                                            <div class="col-lg-8 col-md-8 col-sm-8 col-8 text-right">
                                                <div class="amount">
                                                    <div class="crdDbt">
                                                    <span v-if="currentMoneyRequest.senderaction === 'PENDING'">
                                                        <!--Pending-->
                                                        <span class="myb"></span>
                                                    </span>
                                                        <span v-else-if="currentMoneyRequest.senderaction === 'approve'">
                                                        <!--Approved-->
                                                        <span class="crd"></span>
                                                    </span>
                                                        <span v-else>
                                                        <!--Declined-->
                                                        <span class="dbt"></span>
                                                    </span>
                                                    </div>

                                                    <p v-if="currentMoneyRequest.requestamount">
                                                        <span class="currency">₦</span>
                                                        {{currentMoneyRequest.requestamount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                    <div class="trnxHist">
                                        <div class="row">
                                            <div class="col-lg-4 col-md-4 col-sm-4 col-4">
                                                <p class="histLabel">To</p>
                                            </div>
                                            <div class="col-lg-8 col-md-8 col-sm-8 col-8 text-right">
                                                <p class="histRecord">{{currentMoneyRequest.requestername}} ({{currentMoneyRequest.requesteraccount}})</p>
                                            </div>
                                        </div>
                                    </div>
                                    <hr>

                                    <div class="trnxHist">
                                        <div class="row">
                                            <div class="col-lg-4 col-md-4 col-sm-4 col-4">
                                                <p class="histLabel">Date</p>
                                            </div>
                                            <div class="col-lg-8 col-md-8 col-sm-8 col-8 text-right">
                                                <p class="histRecord">{{currentMoneyRequest.requestdate | formatDateRelatively}}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <hr>

                                    <div class="trnxHist">
                                        <div class="row">
                                            <div class="col-lg-4 col-md-4 col-sm-4 col-4">
                                                <p class="histLabel">Reason</p>
                                            </div>
                                            <div class="col-lg-8 col-md-8 col-sm-8 col-8 text-right">
                                                <p class="histRecord">{{currentMoneyRequest.reason}}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div v-if="currentMoneyRequest.senderaction === 'PENDING'">
                                <div class="modal-button alt pb-2">
                                    <button @click="approveRequest(currentMoneyRequest, 'approve')" class="btn btn-primary btn-xnax-login alt"> <i class="nav-icon i-Checked-User"></i> Approve</button>
                                    <button @click="approveRequest(currentMoneyRequest, 'decline')" class="btn btn-primary btn-xnax-login alt"> <i class="nav-icon i-Data-Block"></i> Decline</button>
                                    <button @click="approveRequest(currentMoneyRequest, 'blacklist')" class="btn btn-primary btn-xnax-login alt"> <i class="nav-icon i-Danger"></i> Blacklist</button>
                                </div>
                            </div>
                            <div v-else>
                                <div class="modal-button alt pb-2">
                                    <button @click="closeModal('moneyRequestActionModal')" class="btn btn-primary btn-xnax-login">Close</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </ui-modal>

                <!--Debit Account Modal-->
                <ui-modal
                        ref="debitAccountModal" transition="scale-up"
                        :removeHeader= "true" size="small" @hide="debitAccountModalHide"
                        align-top :align-top-margin="150"
                >
                    <div class="notification-modal sm">
                        <div class="head">
                            <div class="logo-hold">
                                <div>
                                    <img src="https://assets-base.s3.amazonaws.com/img/rubies/logo-sm.png" alt="" class="logo">
                                </div>
                            </div>
                        </div>

                        <div class="bottom">
                            <div class="modal-body history">
                                <div class="row">
                                    <div class="col-sm-12">
                                        <div class="quickTransfer">

                                            <div class="quickTransferForm">
                                                <div class="alert-box">
                                                    <div class="row">
                                                        <div class="col-sm-12">
                                                            <ui-alert @dismiss="alert.show = false" :type="alert.type" v-show="alert.show">
                                                                {{alert.message}}
                                                            </ui-alert>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="row">
                                                    <div class="col-sm-12 form-group mb-2">
                                                        <label class="form-label">Debit Account*</label>
                                                        <ui-select
                                                                ref="debitAccountSelect"
                                                                placeholder="Select Debit Account"
                                                                type="basic"
                                                                :options="dat"
                                                                v-model="debitAcct"
                                                        ></ui-select>
                                                    </div>


                                                    <div v-if="changeAmount" class="col-sm-12 form-group mb-2">
                                                        <label for="amount" class="form-label">Amount</label>
                                                        <div class="amount-input">
                                                            <div class="currency">
                                                                <span>&#8358;</span>
                                                            </div>

                                                            <input
                                                                    type="text" id="amount" class="input"
                                                                    value="" data-type="currency" placeholder="Amount" data-vv-name="Amount"
                                                                    v-model="amount" name="amount" v-on:keypress="isNumber($event)" required
                                                                    @change="amountOnChange(amount)"
                                                            >
                                                        </div>
                                                    </div>

                                                    <div v-if="changeAmount" class="col-sm-12 form-group mb-2">
                                                        <label for="amount" class="form-label">Comment</label>

                                                        <input
                                                                type="text" id="comment" class="form-input form-control"
                                                                value="" placeholder="Comment (for counter amount)"
                                                                v-model="comment" name="comment" required
                                                        >
                                                        <span v-show="errors.has('comment')" class="error-span is-danger">{{ errors.first('comment') }}</span>
                                                    </div>

                                                    <div class="col-sm-12 form-group mb-0">
                                                        <div class="checkbox-row mb-0">
                                                            <div class="checkbox-container">
                                                                <label class="checkbox" for="save-bene">
                                                                    <input type="checkbox" id="save-bene"  v-model="changeAmount">
                                                                    <div class="checkbox-box" aria-hidden="true">
                                                                        <div class="checkbox-outer">
                                                                            <div class="checkbox-inner"></div>
                                                                        </div>
                                                                    </div>

                                                                    <span class="checkbox-label">Change Amount</span>
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="modal-button">
                                <button @click="confirmDebitAccount()" class="btn btn-primary btn-xnax-login ">OK</button>
                            </div>
                        </div>
                    </div>
                </ui-modal>

                <!--Pin Modal-->
                <ui-modal
                        ref="pinModal" transition="scale-up"
                        :removeHeader= "true" size="small" @hide="closePinModal"
                        align-top :align-top-margin="150"
                >
                    <div class="notification-modal sm">
                        <div class="head">
                            <div class="logo-hold">
                                <div>
                                    <img src="https://assets-base.s3.amazonaws.com/img/rubies/logo-sm.png" alt="" class="logo">
                                </div>
                            </div>
                        </div>

                        <div class="bottom">
                            <div class="modal-body transaction-pin">
                                <div class="alert-box">
                                    <div class="row">
                                        <div class="col-sm-12">
                                            <ui-alert @dismiss="alert.show = false" :type="alert.type" v-show="alert.show">
                                                {{alert.message}}
                                            </ui-alert>
                                        </div>
                                    </div>
                                </div>


                                <div class="row">
                                    <div class="col-sm-12">
                                        <div class="pin-component">

                                            <div class="setPinBox">
                                                <div class="pinHolder">
                                                    <span class="pinIndex" :class="{'active': passcode.length > 0}"></span>
                                                    <span class="pinIndex" :class="{'active': passcode.length > 1}"></span>
                                                    <span class="pinIndex" :class="{'active': passcode.length > 2}"></span>
                                                    <span class="pinIndex" :class="{'active': passcode.length > 3}"></span>
                                                    <span class="pinIndex" :class="{'active': passcode.length > 4}"></span>
                                                    <span class="pinIndex" :class="{'active': passcode.length > 5}"></span>
                                                </div>
                                            </div>

                                            <div class="num-pad confirmation-key-pad">
                                                <div class="key-pad">
                                                    <div class="key-row">
                                                        <div class="key-stroke" @click="tPinInputNo(1)">1</div>
                                                        <div class="key-stroke" @click="tPinInputNo(2)">2</div>
                                                        <div class="key-stroke" @click="tPinInputNo(3)">3</div>
                                                    </div>

                                                    <div class="key-row">
                                                        <div class="key-stroke" @click="tPinInputNo(4)">4</div>
                                                        <div class="key-stroke" @click="tPinInputNo(5)">5</div>
                                                        <div class="key-stroke" @click="tPinInputNo(6)">6</div>
                                                    </div>

                                                    <div class="key-row">
                                                        <div class="key-stroke" @click="tPinInputNo(7)">7</div>
                                                        <div class="key-stroke" @click="tPinInputNo(8)">8</div>
                                                        <div class="key-stroke" @click="tPinInputNo(9)">9</div>
                                                    </div>

                                                    <div class="key-row">
                                                        <div class="key-stroke" @click="clear()">
                                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 487.4 487.4">
                                                                <path d="M438.7 179.1c-3.8 3.6-7.5 7.2-11.1 10.9 -6.2-33.6-19.8-65.6-44.5-94.3 -66.7-77.4-187.1-108.5-275-49.5C30.2 98.6-12.7 197.8 3.4 288.9 21.2 390.4 104.4 484.2 220.3 470.5c63.1-7.4 119.9-38.6 159.6-83.7 0.8-0.7 1.5-1.5 2.3-2.3 0.9-1 1.7-2 2.4-3.1 1.6-2.5 2.8-5.3 3.4-8.3l0.5-2.5c2.7-13.8-7.2-27.7-21.7-30.5 -8.5-1.6-16.9 0.9-23 6.1 -2.4 2-4.4 4.5-5.9 7.3 -0.3 0.6-0.8 1.2-1 1.9 -0.1-0.1-0.3-0.1-0.4-0.2 -39.2 45-98.6 74.4-160.2 63C74.4 399.2 38 282.1 62.2 197.4 83.2 124.3 152.9 50.5 240.3 68.8c52.1 11 105.6 47.6 125.1 96.5 2 5.1 3.8 10.2 5.3 15.4 -7.1-5.9-14.6-11.5-22.4-16.7 -12.3-8-27.7-9.4-38.2 2.1 -8.7 9.5-9.4 28.5 2.9 36.5 16.4 10.8 30.7 23.1 43.2 37 7.5 8.4 14.4 17.5 20.5 27.2 1.3 2.1 2.7 4.3 4 6.5 6.2 10.7 16.1 13.6 25.2 11.7 7.4-0.1 14.6-2.7 18.9-8.5 3-4 6-7.9 9-11.8 3.3-4.3 6.7-8.5 10.1-12.6 11.1-13.5 22.9-26.5 35.8-38.6C504.5 190.4 463.3 156.1 438.7 179.1z"></path>
                                                            </svg>
                                                        </div>
                                                        <div class="key-stroke" @click="tPinInputNo(0)">0</div>
                                                        <div class="key-stroke" @click="backspace()">
                                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                                                <path d="M490.7 64H133.1c-7.2 0-13.9 3.6-17.8 9.6L3.5 244.3c-4.6 7.1-4.6 16.3 0 23.4l111.7 170.7c3.9 6 10.7 9.6 17.8 9.6h357.6c11.8 0 21.3-9.6 21.3-21.3V85.3C512 73.6 502.4 64 490.7 64zM469.3 405.3H144.6L46.8 256l97.8-149.3h324.7V405.3z"></path>
                                                                <path d="M198.2 356.4c8.3 8.3 21.8 8.3 30.2 0l70.2-70.2 70.2 70.2c8.3 8.3 21.8 8.3 30.2 0s8.3-21.8 0-30.2L328.8 256l70.2-70.2c8.3-8.3 8.3-21.8 0-30.2s-21.8-8.3-30.2 0l-70.2 70.2 -70.2-70.2c-8.3-8.3-21.8-8.3-30.2 0 -8.3 8.3-8.3 21.8 0 30.2L268.5 256l-70.2 70.2C189.9 334.6 189.9 348.1 198.2 356.4z"></path>
                                                            </svg>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </ui-modal>

                <!--UI Modal For Displaying Transfer Success Message-->
                <ui-modal
                        ref="transferSuccessModal" transition="scale-up"
                        :removeHeader= "true" size="small"  @hide="transferStatusModalHide"
                        align-top :align-top-margin="200"
                >
                    <div class="notification-modal sm">
                        <div class="head">
                            <div class="logo-hold">
                                <div>
                                    <img src="https://assets-base.s3.amazonaws.com/img/rubies/logo-sm.png" alt="" class="logo">
                                </div>
                            </div>
                        </div>

                        <div class="bottom">
                            <div class="modal-body">
                                <div class="row">
                                    <div class="col-2">
                                        <div class="left">
                                            <div class="status-icon">
                                                <svg class="success" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 496.2 496.2">
                                                    <path d="M496.2 248.1c0-137-111.1-248.1-248.1-248.1C111.1 0 0 111.1 0 248.1c0 137 111.1 248.1 248.1 248.1C385.1 496.2 496.2 385.1 496.2 248.1z"></path>
                                                    <path d="M384.7 165c-5.8-15.1-17.7-12.7-30.6-10.1 -7.7 1.6-42 11.6-96.1 68.8 -22.5 23.7-37.3 42.6-47.1 57 -6-7.3-12.8-15.2-20-22.3 -22.1-22.1-46.7-37.2-47.7-37.9 -10.3-6.3-23.8-3.1-30.2 7.3 -6.3 10.3-3.1 23.8 7.2 30.2 0.2 0.1 21.4 13.2 39.6 31.5 18.6 18.6 35.5 43.8 35.7 44.1 4.1 6.2 11 9.8 18.3 9.8 1.2 0 2.5-0.1 3.8-0.3 8.6-1.5 15.4-7.9 17.5-16.3 0.1-0.2 8.8-24.3 54.7-72.7 37-39.1 61.7-51.5 70.3-54.9 0.1 0 0.1 0 0.3 0 0 0 0.3-0.1 0.8-0.4 1.5-0.6 2.3-0.8 2.3-0.8 -0.4 0.1-0.6 0.1-0.6 0.1l0-0.1c4-1.7 11.4-4.9 11.5-5C385.4 188.2 389 176.2 384.7 165z" fill="#FFF"></path>
                                                </svg>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-10 pl-2">
                                        <div class="right">
                                            <p>
                                                Congratulations!! <br>
                                                {{successMessage}}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="modal-button">
                                <button @click="closeModal('transferSuccessModal')" class="btn btn-primary btn-xnax-login ">Ok</button>
                            </div>
                        </div>
                    </div>
                </ui-modal>

                <!--UI Modal For Displaying Transfer Failed Message-->
                <ui-modal
                        ref="transferFailModal" transition="scale-up"
                        :removeHeader= "true" size="small"  @hide="transferStatusModalHide"
                        align-top :align-top-margin="200"
                >
                    <div class="notification-modal sm">
                        <div class="head">
                            <div class="logo-hold">
                                <div>
                                    <img src="https://assets-base.s3.amazonaws.com/img/rubies/logo-sm.png" alt="" class="logo">
                                </div>
                            </div>
                        </div>

                        <div class="bottom">
                            <div class="modal-body">
                                <div class="row">
                                    <div class="col-2">
                                        <div class="left">
                                            <div class="status-icon">
                                                <svg class="error" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 455.1 455.1">
                                                    <circle cx="227.6" cy="227.6" r="227.6" fill="#E24C4B"></circle>
                                                    <path d="M455.1 227.6c0 125.2-102.4 227.6-227.6 227.6 -72.5 0-136.5-32.7-177.8-85.3 38.4 31.3 88.2 49.8 142.2 49.8 125.2 0 227.6-102.4 227.6-227.6 0-54-18.5-103.8-49.8-142.2C422.4 91 455.1 155 455.1 227.6z" fill="#D1403F"></path>
                                                    <path d="M331.4 331.4c-8.5 8.5-22.8 8.5-31.3 0l-72.5-72.5 -72.5 72.5c-8.5 8.5-22.8 8.5-31.3 0 -8.5-8.5-8.5-22.8 0-31.3l72.5-72.5 -72.5-72.5c-8.5-8.5-8.5-22.8 0-31.3 8.5-8.5 22.8-8.5 31.3 0l72.5 72.5 72.5-72.5c8.5-8.5 22.8-8.5 31.3 0 8.5 8.5 8.5 22.8 0 31.3l-72.5 72.5 72.5 72.5C339.9 308.6 339.9 322.8 331.4 331.4z" fill="#FFF"></path>
                                                </svg>
                                                <!--<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50">-->
                                                    <!--<circle cx="25" cy="25" r="25" fill="#D75A4A"></circle>-->
                                                    <!--<polyline points="16 34 25 25 34 16 " class="svgA"></polyline>-->
                                                    <!--<polyline points="16 16 25 25 34 34 " class="svgA"></polyline>-->
                                                <!--</svg>-->
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-10 pl-2">
                                        <div class="right">
                                            <p>
                                                Failed!! <br>
                                                {{errorMessage}}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="modal-button">
                                <button @click="closeModal('transferFailModal')" class="btn btn-primary btn-xnax-login ">Ok</button>
                            </div>
                        </div>
                    </div>
                </ui-modal>

                <!--UI Modal For Displaying Transfer Failed Message-->
                <ui-modal
                        ref="transferFailModal2" transition="scale-up"
                        :removeHeader= "true" size="small"  @hide="transferStatusModal2Hide"
                        align-top :align-top-margin="200"
                >
                    <div class="notification-modal sm">
                        <div class="head">
                            <div class="logo-hold">
                                <div>
                                    <img src="https://assets-base.s3.amazonaws.com/img/rubies/logo-sm.png" alt="" class="logo">
                                </div>
                            </div>
                        </div>

                        <div class="bottom">
                            <div class="modal-body">
                                <div class="row">
                                    <div class="col-2">
                                        <div class="left">
                                            <div class="status-icon">
                                                <svg class="error" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 455.1 455.1">
                                                    <circle cx="227.6" cy="227.6" r="227.6" fill="#E24C4B"></circle>
                                                    <path d="M455.1 227.6c0 125.2-102.4 227.6-227.6 227.6 -72.5 0-136.5-32.7-177.8-85.3 38.4 31.3 88.2 49.8 142.2 49.8 125.2 0 227.6-102.4 227.6-227.6 0-54-18.5-103.8-49.8-142.2C422.4 91 455.1 155 455.1 227.6z" fill="#D1403F"></path>
                                                    <path d="M331.4 331.4c-8.5 8.5-22.8 8.5-31.3 0l-72.5-72.5 -72.5 72.5c-8.5 8.5-22.8 8.5-31.3 0 -8.5-8.5-8.5-22.8 0-31.3l72.5-72.5 -72.5-72.5c-8.5-8.5-8.5-22.8 0-31.3 8.5-8.5 22.8-8.5 31.3 0l72.5 72.5 72.5-72.5c8.5-8.5 22.8-8.5 31.3 0 8.5 8.5 8.5 22.8 0 31.3l-72.5 72.5 72.5 72.5C339.9 308.6 339.9 322.8 331.4 331.4z" fill="#FFF"></path>
                                                </svg>
                                                <!--<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50">-->
                                                    <!--<circle cx="25" cy="25" r="25" fill="#D75A4A"></circle>-->
                                                    <!--<polyline points="16 34 25 25 34 16 " class="svgA"></polyline>-->
                                                    <!--<polyline points="16 16 25 25 34 34 " class="svgA"></polyline>-->
                                                <!--</svg>-->
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-10 pl-2">
                                        <div class="right">
                                            <p>
                                                Failed!! <br>
                                                {{errorMessage}}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="modal-button">
                                <button @click="closeModal('transferFailModal2')" class="btn btn-primary btn-xnax-login ">Ok</button>
                            </div>
                        </div>
                    </div>
                </ui-modal>

                <!--Request Target Modal-->
                <ui-modal
                        ref="requestTargetModal" transition="scale-up"
                        :removeHeader= "true" size="small" @hide="requestTargetModalHide"
                        align-top :align-top-margin="150"
                >
                    <div class="notification-modal sm">
                        <div class="head">
                            <div class="logo-hold">
                                <div>
                                    <img src="https://assets-base.s3.amazonaws.com/img/rubies/logo-sm.png" alt="" class="logo">
                                </div>
                            </div>
                        </div>

                        <div class="bottom">
                            <div class="modal-body history">
                                <div class="row">
                                    <div class="col-sm-12">
                                        <div class="quickTransfer">

                                            <div class="quickTransferForm">
                                                <div class="alert-box">
                                                    <div class="row">
                                                        <div class="col-sm-12">
                                                            <ui-alert @dismiss="alert.show = false" :type="alert.type" v-show="alert.show">
                                                                {{alert.message}}
                                                            </ui-alert>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="row">
                                                    <div v-if="selectBeneficiary" class="col-md-12 form-group mb-2 mt-2">
                                                        <label class="form-label">Beneficiary *</label>
                                                        <ui-select
                                                                ref="creditBankSelect"
                                                                placeholder="Select Beneficiary"
                                                                type="image"
                                                                has-search
                                                                validation-rules="required"
                                                                :minLength="1"
                                                                :options="beneficiaryList"
                                                                v-model="targetBeneficiary"
                                                        ></ui-select>
                                                    </div>
                                                    <div v-else class="col-md-12 form-group mb-2 mt-2">
                                                        <label for="phone-number" class="form-label">Phone Number/Account Number *</label>
                                                        <input type="text" class="form-input form-control" id="phone-number" name="creditAccount"
                                                               placeholder="Enter Phone Number or Account Number" v-model="phoneNumber"
                                                               data-vv-name="Phone Number/Account No"
                                                               required v-validate="'required|numeric|max:10|min:10'"
                                                        >
                                                        <span v-show="errors.has('phoneNumber')" class="error-span is-danger">{{ errors.first('phoneNumber') }}</span>
                                                    </div>


                                                    <div class="col-sm-12 form-group mb-0">
                                                        <div class="checkbox-row mb-0">
                                                            <div class="checkbox-container">
                                                                <label class="checkbox" for="save-bene">
                                                                    <input type="checkbox" id="select-bene"  v-model="selectBeneficiary">
                                                                    <div class="checkbox-box" aria-hidden="true">
                                                                        <div class="checkbox-outer">
                                                                            <div class="checkbox-inner"></div>
                                                                        </div>
                                                                    </div>

                                                                    <span class="checkbox-label">Select Beneficiary</span>
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="modal-button">
                                <button @click="confirmPhoneOrAccountNo(phoneNumber)" class="btn btn-primary btn-xnax-login ">Next</button>
                            </div>
                        </div>
                    </div>
                </ui-modal>

                <!--New Money Request Modal-->
                <ui-modal
                        ref="newRequestModal" transition="scale-up"
                        :removeHeader= "true" size="small" @hide="newRequestModalHide"
                        align-top :align-top-margin="50"
                >
                    <div class="notification-modal sm">
                        <div class="head">
                            <div class="logo-hold">
                                <div>
                                    <img src="https://assets-base.s3.amazonaws.com/img/rubies/logo-sm.png" alt="" class="logo">
                                </div>
                            </div>
                        </div>

                        <div class="bottom">
                            <div class="modal-body history">
                                <div class="row">
                                    <div class="col-sm-12">
                                        <div class="quickTransfer">
                                            <div class="account-info">
                                                <p class="alias">{{alias}}</p>
                                                <p class="name">{{requestTargetResponse.customername}}</p>
                                                <p class="account">
                                                    {{requestTargetResponse.accountno+ ' ('+requestTargetResponse.countrycode+''+requestTargetResponse.mobilenumber+')'}}
                                                </p>
                                            </div>

                                            <div class="quickTransferForm">
                                                <div class="alert-box">
                                                    <div class="row">
                                                        <div class="col-sm-12">
                                                            <ui-alert @dismiss="alert.show = false" :type="alert.type" v-show="alert.show">
                                                                {{alert.message}}
                                                            </ui-alert>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="row">

                                                    <div class="col-sm-12 form-group mb-2">
                                                        <label class="form-label">Credit Account*</label>
                                                        <ui-select
                                                                ref="debitAccountSelect"
                                                                placeholder="Select Credit Account"
                                                                type="basic"
                                                                :options="dat"
                                                                v-model="debitAcct"
                                                        ></ui-select>
                                                    </div>

                                                    <div class="col-sm-12 form-group mb-2">
                                                        <label for="amount" class="form-label">Amount*</label>
                                                        <div class="amount-input">
                                                            <div class="currency">
                                                                <span>&#8358;</span>
                                                            </div>
                                                            <input
                                                                    type="text" id="requestAmount" class="input"
                                                                    value="" data-type="currency" placeholder="Amount" data-vv-name="Amount"
                                                                    v-model="requestAmount" name="requestAmount" v-on:keypress="isNumber($event)"
                                                                    required @change="amountOnChange2(requestAmount)"
                                                            >
                                                        </div>
                                                    </div>

                                                    <div class="col-sm-12 form-group mb-2">
                                                        <label for="requestReason" class="form-label">Reason</label>

                                                        <input
                                                                type="text" id="requestReason" class="form-input form-control"
                                                                value="" placeholder="Reason"
                                                                v-model="requestReason" name="requestReason" required
                                                        >
                                                        <span v-show="errors.has('requestReason')" class="error-span is-danger">{{ errors.first('requestReason') }}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="modal-button">
                                <button @click="sendNewMoneyRequest()" class="btn btn-primary btn-xnax-login ">Send</button>
                            </div>
                        </div>
                    </div>
                </ui-modal>

              <!--Account Upgrade Modal-->
              <ui-modal
                  ref="accountUpgradeModal" transition="scale-up"
                  :removeHeader="true" size="small" @hide="closeAccountUpgradeModal"
                  align-top :align-top-margin="50"
              >
                <div class="notification-modal sm">
                  <div class="head">
                    <div class="logo-hold">
                      <div>
                        <img src="https://assets-base.s3.amazonaws.com/img/rubies/logo-sm.png" alt="" class="logo">
                      </div>
                    </div>
                  </div>

                  <div class="bottom">
                    <div class="modal-body transaction-pin">



                      <div class="row">
                        <div class="col-sm-12">
                          <p class="warning-msg">
                            You have to upgrade your account to enable you perform transactions.
                            <br />
                            Kindly upgrade your account on the app and try again.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </ui-modal>

            </div>

            <footer-mobile></footer-mobile>
        </div>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'
    import MobileLeftBar from '../sidebar/MobileLeftBar'
    import FooterMobile from "../utility/FooterMobile";


    export default {
        name: "MoneyRequest",
        components: {
            FooterMobile,
            mobileLeftBar: MobileLeftBar,
        },
        props: { },
        data () {
            return {
                currentMoneyRequestList: [],
                currentMoneyRequest: {},
                currentIBanker: [],

                changeAmount: false,
                amount: '',
                comment: '',

                orderedAccountList: [],
                totalAvailableBalance: 0,
                requestSwitch: false,

                _requestForAction: {},
                _action: '',
                passcode: '',

                successMessage: '',
                errorMessage: '',

                debitAcct:  '',
                debitAcctTouched:  false,

                requestDebitAcct:  '',
                requestDebitAcctTouched:  false,

                targetBeneficiary: '',
                beneficiaryList: [],

                phoneNumber: '',
                requestTargetResponse: '',
                requestAmount: '',
                requestReason: '',

                alias: '',
                dat: [],

                selectBeneficiary: false,

                testAmount: '',

                fetchError: 'No Record Found!',

                alert: {
                    show: false,
                    type: 'error',
                    message: 'Something Went Wrong!'
                },
            }
        },
        computed: {
            ...mapGetters([
                'getSideBarPage',
                'getInsideCurrentPage',
                'getUsername',
                'getDataOnLogin',
                'getMoneyRequestSentList',
                'getMoneyRequestReceivedList',
                'getIBankerList',
              'getIfAccountHasBeenUpgraded'
            ])
        },
        created () {
            this.currentMoneyRequestList = this.getMoneyRequestSentList.sort(this.dynamicSort("-requestdate"));

            this.orderedAccountList = this.getDataOnLogin.accountlist.sort(this.compare);

            this.totalAvailableBalance = this.orderedAccountList.map((elem)=>{
                return parseFloat(elem.availablebalance)
            })

            this.popDebitAcct()
            this.popBeneficiaryList()
        },
        methods: {
            ...mapActions([
                'updateNetworkErrorState',
                'updateAppLoading',
                'updateSideBarPage',
                'updateInsideCurrentPage',
                'updateCurrentAccountForAction',
                'updateMoneyRequestSentList',
                'updateMoneyRequestReceivedList',
                'updateCurrentAccountForAction',
            ]),

            backButton(){
                this.updateInsideCurrentPage('dashboard');
                this.updateSideBarPage('dashboard');
            },
            openModal(ref) {
                this.$refs[ref].open();
            },
            closeModal(ref) {
                this.$refs[ref].close();
            },


            //Dynamic Sort
            dynamicSort(property) {
                let sortOrder = 1;

                if(property[0] === "-") {
                    sortOrder = -1;
                    property = property.substr(1);
                }

                return function (a,b) {
                    if(sortOrder === -1){
                        return b[property].localeCompare(a[property]);
                    }else{
                        return a[property].localeCompare(b[property]);
                    }
                }
            },
            //compare
            compare(a,b) {
                if (a.availablebalance > b.availablebalance)
                    return 1;
                if (a.availablebalance < b.availablebalance)
                    return -1;
                return 0;
            },
            getSum(total, num) {
                return total + num;
            },

            reviewSwitchState(){
                if (this.requestSwitch === true){
                    // equate the currentMoneyRequest to the sent requests in the store
                    this.currentMoneyRequestList = this.getMoneyRequestSentList.sort(this.dynamicSort("-requestdate"))
                }
                else {
                    // equate the currentMoneyRequest to the Received requests in the store
                    this.currentMoneyRequestList = this.getMoneyRequestReceivedList.sort(this.dynamicSort("-requestdate"))
                }

                // console.log('Rest..')
            },

            moreRequestInfo(_request){
                // console.log('Selected Banker ==>', _request);

                this.currentMoneyRequest = _request;

                //Show Success Modal and then redirect to the home page / login page
                this.openModal('fullMoneyRequestModal');
            },
            requestAction(_request){
                // console.log('Request Action Selected Banker ==>', _request);

                this.currentMoneyRequest = _request;

                //Show Success Modal and then redirect to the home page / login page
                this.openModal('moneyRequestActionModal');
            },
            approveRequest(_requestForAction, _action){
                // 1. equate the parameters
                this._requestForAction = _requestForAction
                this._action = _action
                // 2. close the request action modal
                this.closeModal('moneyRequestActionModal')

                if (_action === 'approve'){
                    this.amount =this.currentMoneyRequest.requestamount;

                    this.openDebitAccountModal()
                }
                else {
                    // 3. open the pin modal
                    this.openModal('pinModal');
                }
            },
            popDebitAcct(){
                let sdat = [];
                let sample = {};

                for (let i = 0; i < this.getDataOnLogin.accountlist.length; i++){

                    if (this.getDataOnLogin.accountlist[i].account_type === 'IBANKER'){
                        // console.log('I Banker Account')
                    } else {
                        sample.label = this.getDataOnLogin.accountlist[i].accountno + " - ₦" + this.$options.filters.moneyFormat(this.getDataOnLogin.accountlist[i].availablebalance);
                        sample.value = this.getDataOnLogin.accountlist[i];

                        sdat.push(sample)

                        sample = {}
                    }
                }
                this.dat = sdat;
            },
            popBeneficiaryList(){
                let sdat = [];
                let sample = {};
                let ftbeneficiaries = this.getDataOnLogin.ftbeneficiaries

                // // console.log('ACCOunt ++====>>>', this.getDataOnLogin.accountlist)
                for (let i = 0; i < ftbeneficiaries.length; i++){
                    if (ftbeneficiaries[i].bankname === "HighStreet MFB"){
                        sample.label = ftbeneficiaries[i].accountname;
                        sample.value = ftbeneficiaries[i].accountnumber;
                        sample.image = "https://s3.amazonaws.com/rubiesstore/090175.png"

                        sdat.push(sample)
                        sample = {}
                    }

                }

                this.beneficiaryList = sdat;
            },
            confirmDebitAccount(){
                if (this.debitAcct === undefined || this.debitAcct === ''){
                    // display error notification
                    this.showAlert(true, 'error', 'Please Select Debit Account*')
                }
                else if(this.amount === undefined || this.amount === ''){
                    // display error notification
                    this.showAlert(true, 'error', 'Please Enter Amount*')
                }
                else {
                    // reset Alert
                    this.alert.show = false;

                    //remove commas from amount
                    this.amount = this.amount.replace(/,/g, '');

                    // console.log('Debit Account', this.debitAcct)
                    // console.log('Amount', this.amount)


                    setTimeout(()=>{
                        this.closeDebitAccountModal()

                        // 3. open the pin modal
                        this.openModal('pinModal');
                    }, 800);
                }
            },
            ConsumeFinalAPI(){
                //start app running
                this.updateAppLoading(true);

                // console.log('debitAcct ==>>', this.debitAcct);

                let bodyToSend = {
                    action: this._action,
                    requestercustomerid: this._requestForAction.requestercustomerid,
                    requestid: this._requestForAction.requestid,
                    username: this.getUsername,
                    pin: this.passcode,
                };

                if (this.debitAcct !== ''){
                    bodyToSend.account= this.debitAcct.value.accountno
                }
                if (this.amount !== this.currentMoneyRequest.requestamount){
                    bodyToSend.comment = this.comment
                    bodyToSend.amount = this.amount
                }
                // reset pin
                this.passcode = '';

                // console.log('body to send ==>>', bodyToSend);

                axios
                    .post('/requestmoneyresponse', bodyToSend,
                        {
                            headers : {
                                'Authorization': this.getDataOnLogin.authorization,
                                'Content-Type': 'application/json',
                                'Access-Control-Allow-Origin': '*'
                            }})
                    .then(response => {
                        //stop app running
                        this.updateAppLoading(false);

                        let responseData =  response.data;

                        // console.log('responseData ==>>', responseData)

                        if (responseData.responsecode === '00') {
                            // console.log('TRANSFER SUCCESS');

                            //hide pin Modal
                            this.closePinModal();

                            // equate the response message and show transferSuccessModal
                            this.successMessage = responseData.responsemessage;
                            this.openTransferSuccessModal();
                        }
                        else if (responseData.responsecode === '18'){
                            // console.log('Invalid tPIN');
                            this.passcode = '';

                            // display error notification
                            this.showAlert(true, 'error', responseData.responsemessage)
                        }
                        else {
                            // console.log('Other Errors');
                            //hide pin Modal
                            this.closePinModal();

                            // Clear the last passcode
                            this.passcode = '';

                            // equate the response message and show transferFailModal
                            this.errorMessage = responseData.responsemessage;
                            this.openTransferFailModal();
                        }
                    })
                    .catch(error => {
                        //stop app running
                        this.updateAppLoading(false);

                        // log Error
                        // console.log(error);

                        // set network error state to true
                        this.updateNetworkErrorState(true);
                    })
            },
            refetchMoneyRequestList(){
                //start app loading
                this.updateAppLoading(true);

                let bodyToSend = {
                    username: this.getUsername
                }

                axios
                    .post('/requestmoneysentlist', bodyToSend,
                        {
                            headers : {
                                'Authorization': this.getDataOnLogin.authorization,
                                'Content-Type': 'application/json',
                                'Access-Control-Allow-Origin': '*'
                            }})
                    .then(response => {
                        //stop app running
                        // this.updateAppLoading(false);

                        let responseData =  response.data;

                        // console.log('responseData ===>>', responseData)


                        if (responseData.responsecode === '00' || responseData.responsecode === '01') {

                            if (responseData.responsecode === '01'){
                                this.updateMoneyRequestSentList([])

                                this.fetchError = responseData.responsemessage
                            } else {
                                this.updateMoneyRequestSentList(responseData.result)
                            }
                            axios
                                .post('/requestmoneyreceivedlist', bodyToSend,
                                    {
                                        headers : {
                                            'Authorization': this.getDataOnLogin.authorization,
                                            'Content-Type': 'application/json',
                                            'Access-Control-Allow-Origin': '*'
                                        }})
                                .then(response2 => {
                                    //stop app running
                                    this.updateAppLoading(false);

                                    let responseData2 =  response2.data;

                                    // console.log('responseData2 ==>>', responseData2)

                                    if (responseData2.responsecode === '00' || responseData.responsecode === '01') {
                                        if (responseData.responsecode === '01'){
                                            this.updateMoneyRequestReceivedList([])
                                            this.fetchError = responseData.responsemessage

                                        } else {
                                            this.updateMoneyRequestReceivedList(responseData2.result)
                                        }

                                        //update "sideBarPage" in the store
                                        this.updateSideBarPage('money-request');

                                        //Update the current sub component in the store
                                        // this.updateInsideCurrentPage('moneyRequest')

                                        this.reviewSwitchState()
                                    } else {
                                        // display error notification
                                        this.showAlert(true, 'error', responseData.responsemessage)
                                    }
                                })
                                .catch(error => {
                                    //stop app running
                                    this.updateAppLoading(false);

                                    // log Error
                                    // console.log(error);

                                    // set network error state to true
                                    this.updateNetworkErrorState(true);
                                })

                        } else {

                            // display error notification
                            this.showAlert(true, 'error', responseData.responsemessage)
                        }
                    })
                    .catch(error => {
                        //stop app running
                        this.updateAppLoading(false);

                        // log Error
                        // console.log(error);

                        // set network error state to true
                        this.updateNetworkErrorState(true);
                    })
            },
            transferStatusModalHide(){
                // refetch the money request list
                this.refetchMoneyRequestList()
            },
            transferStatusModal2Hide(){},

            fullMoneyRequestModalHide(){},
            debitAccountModalHide(){},
            requestTargetModalHide(){},
            newRequestModalHide(){},

            showAlert(show, type, message){
                this.alert.show = show;
                this.alert.type = type;
                this.alert.message = message;
            },
            generateUUID() {
                let d = new Date().getTime();
                let uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                    let r = (d + Math.random() * 16) % 16 | 0;
                    d = Math.floor(d / 16);
                    return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16)
                });
                localStorage.test = uuid;
                return uuid
            },
            isNumber(evt) {
                evt = (evt) ? evt : window.event;
                let charCode = (evt.which) ? evt.which : evt.keyCode;
                if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                    evt.preventDefault();
                } else {
                    return true;
                }
            },
            tPinInputNo(no){
                //    input The incoming number
                this.passcode = this.passcode + no;
                //    check if passcode length is up to 6 now
                this.tPinLengthCheck();
            },
            backspace() {
                this.passcode = this.passcode.slice(0, -1);
            },
            clear() {
                this.passcode = '';
            },
            tPinLengthCheck(){
                if (this.passcode.length === 6) {
                    //    consume API or do the next thing
                    this.ConsumeFinalAPI()
                }
            },


            amountOnChange(_incomingAmount){
                if(_incomingAmount.length === 0){
                    _incomingAmount = '0'
                }
                // _incomingAmount = _incomingAmount.replace(/,/g, '');

                let outgoingAmount = this.cleanAmount(_incomingAmount);
                let indexOfThePoint = outgoingAmount.indexOf('.');

                String.prototype.insert = function (index, string) {
                    if (index > 0)
                        return this.substring(0, index) + string + this.substring(index, this.length);
                    return string + this;
                };
                let answer = outgoingAmount
                let count = 0
                for (let i = indexOfThePoint; i >= 1; i--){
                    if(count === 3){
                        count = 1
                        answer = answer.insert(i, ",")
                    }
                    else {
                        count++
                    }
                }

                this.amount = answer;
            },
            cleanAmount(_amount){
                _amount = _amount.replace(/,/g, '');
                _amount = (parseFloat(_amount).toFixed(2)).toString();

                return _amount
            },

            amountOnChange2(_incomingAmount){
                if(_incomingAmount.length === 0){
                    _incomingAmount = '0'
                }

                _incomingAmount = _incomingAmount.replace(/,/g, '');


                let outgoingAmount = (parseFloat(_incomingAmount).toFixed(2)).toString();
                let indexOfThePoint = outgoingAmount.indexOf('.');

                String.prototype.insert = function (index, string) {
                    if (index > 0)
                        return this.substring(0, index) + string + this.substring(index, this.length);
                    return string + this;
                };
                let answer = outgoingAmount
                let count = 0
                for (let i = indexOfThePoint; i >= 1; i--){
                    if(count === 3){
                        count = 1
                        answer = answer.insert(i, ",")
                    }
                    else {
                        count++
                    }
                }
                this.requestAmount = answer
            },

            openPinModal(){
              //check if account has been upgraded?
              let upgradeAccount = this.getIfAccountHasBeenUpgraded;
              if (upgradeAccount !== 'N' && upgradeAccount !== 'tier0' && upgradeAccount !== 'tier1.1') {
                //Open The PIn Modal
                this.openModal('pinModal');
              } else {
                this.openAccountUpgradeModal()
              }
            },
            closePinModal(){
                //Close the Pin Modal
                this.closeModal('pinModal')

                this._requestForAction = {}
                this._action = ''
                this.debitAcct = ''
            },
            openTransferSuccessModal(){
                //Open The TransferSuccessModal
                this.openModal('transferSuccessModal');
            },
            closeTransferSuccessModal(){
                //Close the TransferSuccessModal
                this.closeModal('transferSuccessModal')
            },
            openTransferFailModal(){
                //Open The TransferSuccessModal
                this.openModal('transferFailModal');
            },
            closeTransferFailModal(){
                //Close the TransferSuccessModal
                this.closeModal('transferFailModal')
            },
            openTransferFailModal2(){
                //Open The TransferSuccessModal
                this.openModal('transferFailModal2');
            },
            closeTransferFailModal2(){
                //Close the TransferSuccessModal
                this.closeModal('transferFailModal2')
            },
            openDebitAccountModal(){
                //Open The TransferSuccessModal
                this.openModal('debitAccountModal');
            },
            closeDebitAccountModal(){
                //Close the TransferSuccessModal
                this.closeModal('debitAccountModal')
            },
            openRequestTargetModal(){
                //Open The TransferSuccessModal
                this.openModal('requestTargetModal');
            },
            closeRequestTargetModal(){
                //Close the TransferSuccessModal
                this.closeModal('requestTargetModal')
            },
            openNewRequestModal(){
                //Open The TransferSuccessModal
                this.openModal('newRequestModal');
            },
            closeNewRequestModal(){
                //Close the TransferSuccessModal
                this.closeModal('newRequestModal')
            },
            openAccountUpgradeModal(){
              //Open The TransferSuccessModal
              this.openModal('accountUpgradeModal');
            },
            closeAccountUpgradeModal(){
              //Close the TransferSuccessModal
              this.closeModal('accountUpgradeModal');
              //Update the current sub component in the store
              this.updateInsideCurrentPage('dashboard')
            },


            startNewMoneyRequest(){
                // console.log('New Money Request')

                this.openRequestTargetModal();
            },
            confirmPhoneOrAccountNo(_phoneNumber){
                if (_phoneNumber === ''){
                    if (this.selectBeneficiary){
                        if (this.targetBeneficiary === undefined || this.targetBeneficiary === ''){
                            // display error notification
                            this.showAlert(true, 'error', 'Please Select Beneficiary*')
                        }
                        else {
                            // console.log('Beneficiary==>', this.targetBeneficiary.value);
                            _phoneNumber = this.targetBeneficiary.value;
                        }
                    }
                    else {
                        // display error notification
                        this.showAlert(true, 'error', 'Please Enter Phone Number or Account Number')
                    }
                }

                if (_phoneNumber.length < 10 || _phoneNumber.length > 14){
                    // display error notification
                    this.showAlert(true, 'error', 'Please Enter Phone Number or Account Number')
                }
                else {
                    let queryType = '';
                    let accountNo = '';
                    let countryCode = '';
                    let phoneNumber = '';


                    if (_phoneNumber.length === 10){
                        // its an account number
                        queryType = 'accountnumber';

                        accountNo = _phoneNumber;
                    }
                    else {
                        // its a phone number
                        queryType = 'mobilenumber';

                        if (_phoneNumber.length === 11) {
                            countryCode = '234';
                            phoneNumber = _phoneNumber;
                        }
                        else {
                            countryCode = _phoneNumber.substring(0, 3);
                            phoneNumber = _phoneNumber.substring(3, 14);
                        }
                    }

                    //start app running
                    this.updateAppLoading(true);

                    let bodyToSend = {
                        querytype: queryType,
                        accountnumber: accountNo,
                        countrycode: countryCode,
                        mobilenumber: phoneNumber,
                    };

                    // console.log('bodyToSend ==>>', bodyToSend)

                    axios
                        .post('/querycustomer', bodyToSend,
                            {
                                headers : {
                                    'Authorization': this.getDataOnLogin.authorization,
                                    'Content-Type': 'application/json',
                                    'Access-Control-Allow-Origin': '*'
                                }})
                        .then(response => {
                            //stop app running
                            this.updateAppLoading(false);

                            let responseData =  response.data;

                            // reset alert
                            this.alert.show = false;

                            // console.log('responseData ==>>', responseData)

                            if (responseData.responsecode === '00') {
                                // console.log('Recognise Target');

                                //hide pin Modal
                                this.closeRequestTargetModal();

                                this.requestTargetResponse = responseData

                                this.openNewRequestModal()
                            }
                            else {
                                // console.log('Other Errors');
                                //hide pin Modal
                                this.closeRequestTargetModal();


                                // equate the response message and show transferFailModal
                                this.errorMessage = responseData.responsemessage;
                                this.openTransferFailModal2();
                            }
                        })
                        .catch(error => {
                            //stop app running
                            this.updateAppLoading(false);

                            // log Error
                            // console.log(error);

                            // set network error state to true
                            this.updateNetworkErrorState(true);
                        })
                }

            },
            sendNewMoneyRequest(){
                // console.log('Credit Account [DAT] ==>>', this.dat)
                // console.log('Credit Account ==>>', this.debitAcct)

                if (this.debitAcct === undefined || this.debitAcct === ''){
                    // display error notification
                    this.showAlert(true, 'error', 'Please Select Credit Account*')
                }
                else if (this.requestAmount === undefined || this.requestAmount === ''){
                    // display error notification
                    this.showAlert(true, 'error', 'Please Enter Amount')
                }
                else if (this.requestReason === undefined || this.requestReason === ''){
                    // display error notification
                    this.showAlert(true, 'error', 'Please Enter Reason')
                }
                else {
                    //start app running
                    this.updateAppLoading(true);

                    let bodyToSend = {
                        //self
                        sendername: this.requestTargetResponse.customername,
                        sendercountrycode: this.requestTargetResponse.countrycode,
                        senderphonenumber: this.requestTargetResponse.mobilenumber,
                        senderaccountnumber: this.requestTargetResponse.accountno,
                        sendercustomerid: this.requestTargetResponse.custid,

                        //target
                        requesteraccount: this.debitAcct.value.accountno,
                        requestercustomerid: this.getDataOnLogin.customerid,
                        requestername: this.getDataOnLogin.customername,

                        //others
                        reason: this.requestReason,
                        amount: this.cleanAmount(this.requestAmount),
                        requestid: this.generateUUID() + '-' + this.getDataOnLogin.customerid.replace(/\s/g, ''),
                        username: this.getUsername,
                    };


                    // console.log('bodyToSend ==>>', bodyToSend)

                    axios
                        .post('/requestmoney', bodyToSend,
                            {
                                headers : {
                                    'Authorization': this.getDataOnLogin.authorization,
                                    'Content-Type': 'application/json',
                                    'Access-Control-Allow-Origin': '*'
                                }})
                        .then(response => {
                            //stop app running
                            this.updateAppLoading(false);

                            let responseData =  response.data;

                            // reset alert
                            this.alert.show = false;

                            // console.log('responseData ==>>', responseData)

                            if (responseData.responsecode === '00') {
                                // console.log('Recognise Target');

                                //hide New Request Modal
                                this.closeNewRequestModal();

                                this.successMessage = responseData.responsemessage;

                                this.openTransferSuccessModal()
                            }
                            else {
                                // console.log('Other Errors');
                                //hide pin Modal
                                this.closeNewRequestModal();


                                // equate the response message and show transferFailModal
                                this.errorMessage = responseData.responsemessage;
                                this.openTransferFailModal2();
                            }
                        })
                        .catch(error => {
                            //stop app running
                            this.updateAppLoading(false);

                            // log Error
                            // console.log(error);

                            // set network error state to true
                            this.updateNetworkErrorState(true);
                        })
                }
            },
        },
        mounted(){
            this.$nextTick(()=>{});
        },
    }
</script>

<style scoped>
.request-switch{}
.request-switch p{}

.btn-xnax {
    margin-top: 5px;
}
.save-bene {
    padding: 7px 0 0;
}
.num-pad.confirmation-key-pad .key-pad .key-row {
    padding: 0;
}
.num-pad.confirmation-key-pad .key-stroke {
    width: 45px;
    height: 45px;
    display: inline-grid;
    padding: 11px 18px;
    margin: 0 13px 13px 0;
    font-size: 17px;
    font-weight: 500;
    border: 0;
    color: #030303;
    fill: #030303;
    background-color: #e4e4e4;
}
.num-pad.confirmation-key-pad .key-stroke:hover {
    color: #010101;
    fill: #010101;
    text-decoration: none;
    /*background-color: #6d0605;*/
    background-color: #bababa;
}
.setPinBox .pinHolder .pinIndex.active {
    background-color: #030303;
}
.setPinBox .pinHolder .pinIndex {
    background-color: #e4e4e4;
}

.svgA{fill:none;stroke-width:2;stroke:#FFF;}

.checkbox-row {
    padding: 0 5px;
}


.account-info {
    padding: 0 0 15px 13px;
}
.account-info .alias {
    font-size: 8px !important;
    color: #808181;
}
.account-info .name {
    font-size: 14px !important;
    text-transform: uppercase;
    font-weight: 600;
    line-height: 14px;
    margin-bottom: 3px !important;
    margin-top: 2px;
}
.account-info .account {
    font-size: 10px !important;
    line-height: 10px;
    color: #6d0606;
}

.pageSubHeader{
    margin: 0;
    /*color: #c02026;*/
    font-size: 12px;
}
</style>